import ClipboardIcon from './ClipboardIcon';

export default ClipboardIcon;
